export default __webpack_public_path__ + "static/media/x.85664a33.svg";